module.exports = __webpack_public_path__ + "img/initintro.1f77b847.svg";